<template>
	<div class="full" id="statisticsChart"></div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import * as echarts from 'echarts';
	export default {
		props: {

		},
		data() {
			return {
				chart: null,
				sourceData:[],
				groupdata:[],
				// basemonth:0,
				// basecurrent:0,
				create_time:'1704038400,1722441600'
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.createChart()
		},
		computed: {

		},

		methods: {
			createChart() {
				this.$api.supplier.statisticsdata({create_time:this.create_time}).then((res)=>{
					this.sourceData = res.data
					// this.basemonth = res.month
					// this.basecurrent = res.current
					let summonth = res.basenum.month
					let sumcurrent = res.basenum.current
					let groupdata = this.$Lodash.groupBy(res.data, 'create_time')
					for(let i in groupdata){
						groupdata[i] = this.$Lodash.groupBy(groupdata[i], 'paymentmethod')
					}
					for(let i in groupdata){
						let month = groupdata[i][8806]?groupdata[i][8806].length:0
						let current = (groupdata[i][8805]?groupdata[i][8805].length:0 + groupdata[i][8825]?groupdata[i][8825].length:0)
						summonth += month
						sumcurrent += current
						groupdata[i] = {
							month:summonth,
							current:sumcurrent
						}			
					}
					this.groupdata = groupdata
					this.statisticsChart()
					
					
				})
				//this.statisticsChart()
			},
			statisticsChart() {
				let series = []
				let legend  = []
				let xarr = []
				let monthData = []
				let currentData = []
				console.log(this.groupdata)
				for(let i in this.groupdata){
					xarr.push(i)
					monthData.push(this.groupdata[i]['month'])
					currentData.push(this.groupdata[i]['current'])
				}
				series.push({
					name: '现结',
					type: 'bar',
					stack: 'supplier',
					label: {
						show: true,
				
					},
					emphasis: {
						focus: 'series'
					},
					data: currentData
				})
				series.push({
					name: '月结',
					type: 'bar',
					stack: 'supplier',
					label: {
						show: true,
			
					},
					emphasis: {
						focus: 'series'
					},
					data: monthData
				})
			
				if (this.chart) {
					this.chart.clear()
				} else {
					this.chart = echarts.init(document.getElementById('statisticsChart'))
				}
				this.chart.setOption({
					title: {
						text: '供应商增长量',
						right:'46%',
						textStyle: {
							fontSize: 14
						}
					},
					legend: {
						data: legend
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							magicType: {
								show: true,
								type: ['line', 'bar', 'stack']
							},
							restore: {
								show: false
							},
							saveAsImage: {
								show: true
							}
						}
					},
					xAxis: {
						data: xarr
				},
					yAxis: {},
					series: series
				})


				//console.log(xarr,this.tableData)

			}
		},
		components: {

		}
	}
</script>